import React from 'react';
import { connect } from 'react-redux';
import { IAppState } from '../../../../../../state/reducers';
import {
  IProps,
  IStateProps,
} from './interfaces';

const DialogTitle: React.FunctionComponent<IProps> = (props: IProps) => {
  const {
    socialPublishing: {
      settings: publishSettings,
    },
  } = props;

  return (
    <span>
      {`Publish to ${publishSettings.settings.profileName}`}
    </span>
  );
};

const mapStateToProps = (state: IAppState): IStateProps => ({
  socialPublishing: state.publishSelectedAssetsToEndPoints.socialPublishing,
});

export default connect(
  mapStateToProps,
)(DialogTitle);
